import Vue from 'vue'
import { translationProcessing } from './translationProcessing'

export const setupTranslationService = () => {
  translationProcessing.init(({ value, notUpdate = false }) => {
    if (value) {
      Vue.i18n.add('ru', value.data.ru)
      Vue.i18n.add('uk', value.data.uk)
    }
  })
}
